import { getIsOutOfStock } from '../../core';
import { useFiltersResponse, useFilterValues } from '../../filters-management';

export const useIsOutOfStock = () => {
  const filterValues = useFilterValues();
  const filtersResponse = useFiltersResponse();

  return getIsOutOfStock(filterValues, filtersResponse);
};
